import styled from "styled-components";

export const PrevNextNavWrapper = styled.div`
  height: 1.5rem;
  white-space: nowrap;
  display: inline-flex;
  margin-left: ${({ $isPageBottom }) => ($isPageBottom ? "0" : "1rem")};
  margin-top: ${({ $isPageBottom }) => ($isPageBottom ? "1rem;" : "0")};

  @media print {
    display: none;
  }
`;

export const PrevNextNav = styled.div`
  font-size: ${({ theme }) => theme.font.size.sm};
`;
